
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
props: {
except: String
},
methods: {
GoGoodsInfo (name) {
this.$router.push({name: name, query: this.$route.query})
}
},
mounted () {
let btns = [
{
name: 'ImportTariffDetail', title: '进口关税'
},
{
name: 'ImportLinkageTaxDetail', title: '代   征   税'
},
{
name: 'ExportTaxDetail', title: '出口关税'
},
{
name: 'ExportRebatesDetail', title: '出口退税'
},
{
name: 'G_UnitDetail', title: '计量单位'
},
{
name: 'LicensedDetail', title: '监管证件'
}
]
let self = this
btns.reverse().forEach(function (item) {
if (item.name !== self.except) {
self.buttons.push(item)
}
})
},
data () {
return {
buttons: []
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/GoodsInfoBottom.vue